/**
 * SECTOR SEVEN — cartridge palette.
 *
 * Second vector cartridge. Pure black void, neon-green tube wireframe,
 * magenta enemies climbing out, cyan defender on the rim. Atari color-
 * vector aesthetic (Tempest 1981).
 *
 * Like Astrofall, this cartridge uses STROKES only. The 2-pass bloom
 * trick — wide alpha underlay + bright thin overlay — approximates the
 * CRT phosphor halo of the original analog vector tubes.
 */

export const FIELD_BG = '#000000';

// --- Tube wireframe -------------------------------------------------
// The polygonal rim + lane edges. Neon-green phosphor, bloom underlay.
export const TUBE_LINE = '#33ff66';
export const TUBE_BLOOM = 'rgba(51, 255, 102, 0.35)';
// Rim-edge highlight (the polygon facing the camera).
export const RIM_LINE = '#a0ffb0';
export const RIM_BLOOM = 'rgba(160, 255, 176, 0.4)';

// --- Player ---------------------------------------------------------
// Defender on the rim. Cool cyan so it pops against the green tube.
export const PLAYER_LINE = '#7afff0';
export const PLAYER_BLOOM = 'rgba(122, 255, 240, 0.4)';
// Player while diving — dim slightly so the depth-shift reads.
export const PLAYER_DIVE_LINE = '#3fb8e6';
export const PLAYER_DIVE_BLOOM = 'rgba(63, 184, 230, 0.4)';

// --- Bullets --------------------------------------------------------
// Player bullets travel down their lane. Bright cyan dot.
export const BULLET = '#7afff0';
export const BULLET_TRAIL = 'rgba(122, 255, 240, 0.5)';
// Dive-mode bullets get a yellow halo to advertise the 3× damage.
export const BULLET_POWER = '#ffea00';
export const BULLET_POWER_TRAIL = 'rgba(255, 234, 0, 0.55)';

// --- Enemies --------------------------------------------------------
// Magenta wash for the standard enemy class. Each variant has its own
// hue so the player can read threat at a glance:
//   - FLIPPER:  magenta — direct climber + edge flip
//   - SPIKER:   orange — leaves spikes
//   - PULSAR:   pink — pulses invulnerable, lane-kill while pulsing
export const FLIPPER_LINE = '#ff40c0';
export const FLIPPER_BLOOM = 'rgba(255, 64, 192, 0.4)';
export const SPIKER_LINE = '#ff8c1a';
export const SPIKER_BLOOM = 'rgba(255, 140, 26, 0.4)';
export const PULSAR_LINE = '#ff70b0';
export const PULSAR_BLOOM = 'rgba(255, 112, 176, 0.45)';
export const PULSAR_PULSE_LINE = '#ffffff';
export const PULSAR_PULSE_BLOOM = 'rgba(255, 255, 255, 0.55)';

// --- Spikes (Spiker trail) -----------------------------------------
// Persistent yellow line dropped down a lane by the Spiker enemy.
export const SPIKE = '#ffea00';
export const SPIKE_BLOOM = 'rgba(255, 234, 0, 0.35)';

// --- HUD ------------------------------------------------------------
export const HUD_LABEL = '#7af3c8';
export const HUD_SCORE = '#ffea00';
export const HUD_LIVES = '#7afff0';
export const HUD_LEVEL = '#33ff66';
export const HUD_ALERT = '#ff3030';
export const HUD_DIVE = '#ffea00';

// --- Effects --------------------------------------------------------
export const FLASH_HIT = '#ffffff';
export const DIVE_FLASH = 'rgba(255, 234, 0, 0.18)';

/** Tokens the cabinet samples for marquee tinting while this cartridge
 *  is loaded. First entry is the cartridge's hero color — the
 *  phosphor-green that defines its identity. */
export const PALETTE_HINT: readonly string[] = [
  TUBE_LINE, // phosphor-green is the cartridge's signature
  PLAYER_LINE,
  FLIPPER_LINE,
  SPIKE,
];
